/** Helper display per vidimazione FIR cartacei. */

export type VidimBlocco = {
  codice: string;
  descrizione: string;
  disponibili: number | null;
  raw: Record<string, unknown>;
};

function asRecord(v: unknown): Record<string, unknown> {
  return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, unknown>) : {};
}

export function normalizeBlocchi(data: unknown): VidimBlocco[] {
  const list = Array.isArray(data) ? data : Array.isArray(asRecord(data).items) ? asRecord(data).items as unknown[] : [];
  return list.map((item) => {
    const r = asRecord(item);
    const codice = String(
      r.codice_blocco ?? r.codiceBlocco ?? r.codice ?? r.id ?? "—",
    );
    const disp = r.disponibili ?? r.numero_disponibili ?? r.quantita_disponibile;
    return {
      codice,
      descrizione: String(r.descrizione ?? r.label ?? ""),
      disponibili: disp != null && disp !== "" ? Number(disp) : null,
      raw: r,
    };
  });
}

export function formatVidimVerifica(data: unknown): { ok: boolean; lines: { label: string; value: string }[] } {
  const r = asRecord(data);
  const lines: { label: string; value: string }[] = [];
  const push = (label: string, v: unknown) => {
    if (v != null && v !== "") lines.push({ label, value: String(v) });
  };
  push("Numero FIR", r.numero_fir ?? r.numeroFIR);
  push("Stato", r.stato ?? r.stato_vidimazione);
  push("Codice blocco", r.codice_blocco);
  push("Progressivo", r.progressivo);
  push("Data vidimazione", r.data_vidimazione ?? r.dataVidimazione);
  if (lines.length === 0 && Object.keys(r).length > 0) {
    for (const [k, v] of Object.entries(r).slice(0, 12)) {
      if (typeof v !== "object") push(k, v);
    }
  }
  const stato = String(r.stato ?? "").toLowerCase();
  const ok = stato.includes("valid") || stato.includes("attiv") || lines.length > 0;
  return { ok, lines };
}
